module.exports = __webpack_public_path__ + "static/media/instagram.d48f3313.svg";